import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useLocation } from 'react-router-dom';

import useViewer from '@hooks/useViewer';
import useIcscTracking from '@tracking/useIcscTracking';

const TrackPageView = ({ children }) => {
    const { viewer } = useViewer();
    const location = useLocation();
    const { Track, trackEvent } = useIcscTracking();

    useEffect(() => {
        if (!location) return;
        if (!viewer) return;

        trackEvent({ viewer, location });
    }, [location, trackEvent, viewer]);

    return <Track>{children}</Track>;
};

TrackPageView.propTypes = {
    children: PropTypes.node.isRequired,
};

export default TrackPageView;
